
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CoordinateSystemEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;
        ctx.lineWidth = 1 * scale;
        ctx.font = `${9 * scale}px monospace`;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / layerIndex;
            for (let x = x1; x <= x2; x += spacing) {
                ctx.beginPath();
                ctx.moveTo(x, -height * 2);
                ctx.lineTo(x, height * 2);
                ctx.stroke();
                ctx.fillText(`${Math.floor(x)}'W`, x + 5, -height + 20);
            }
            for (let y = y1; y <= y2; y += spacing) {
                ctx.beginPath();
                ctx.moveTo(-width * 2, y);
                ctx.lineTo(width * 2, y);
                ctx.stroke();
                ctx.fillText(`${Math.floor(y)}'N`, -width + 5, y - 5);
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
